import { useState, useRef, useEffect } from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';

// Styled button component positioned on the right side and rotated 90 degrees
const RotateButton = styled(Button)(({ theme }) => ({
  position: 'fixed',
  top: '55%',
  right: '-30px', // Position button partially off-screen on the right
  transform: 'rotate(90deg) translateY(-50%)', // Rotate text to be vertical
  transformOrigin: 'center center',
  zIndex: 999, // Lower z-index than report button
  borderRadius: '0 0 10px 10px', // Rounded bottom corners
  backgroundColor: 'orange',
  color: '#fff',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  '&:hover': {
    backgroundColor: 'darkorange', // Darker orange on hover
    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.2)', // Enhanced shadow on hover
  },
}));

const SurveyForm = () => {
  // State to track the vertical position of the button - Initialize to center
  // const [topOffset, setTopOffset] = useState(() => {
  //   // Calculate initial center position
  //   return window.innerHeight / 2 + 40; // 25px is approximately half button height
  // });

  // Refs for tracking drag state and button element
  const buttonRef = useRef(null);
  const isDragging = useRef(false); // Track if button is being dragged
  const dragStarted = useRef(false); // Track if drag operation has started

  // Handle window resize to keep button within bounds and re-center if needed
  // useEffect(() => {
  //   const handleResize = () => {
  //     if (buttonRef.current) {
  //       const buttonHeight = buttonRef.current.offsetHeight;
  //       const maxTopOffset = window.innerHeight - buttonHeight - 20;
  //       const minTopOffset = 20;

  //       // If button is out of bounds, move it to center
  //       if (topOffset > maxTopOffset || topOffset < minTopOffset) {
  //         setTopOffset(window.innerHeight / 2 - buttonHeight / 2);
  //       }
  //     }
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, [topOffset]);

  // Handle button click - opens survey form in new tab
  const handleButtonClick = () => {
    window.open('https://forms.gle/XRVGFXRJQWWoTKnBA', '_blank');
  };

  // // Start dragging operation on mouse down
  // const startDrag = (e) => {
  //   e.preventDefault();
  //   isDragging.current = true;
  //   dragStarted.current = false;
  //   document.body.style.userSelect = "none"; // Prevent text selection while dragging
  // };

  // // Stop dragging operation on mouse up
  // const stopDrag = () => {
  //   if (isDragging.current) {
  //     isDragging.current = false;
  //     dragStarted.current = true;
  //   }
  //   document.body.style.userSelect = ""; // Re-enable text selection
  // };

  // // Handle mouse movement during drag
  // const onDrag = (e) => {
  //   if (isDragging.current) {
  //     // Calculate new vertical position based on mouse Y coordinate
  //     const newTopOffset = e.clientY - buttonRef.current.offsetHeight / 2;

  //     // Set boundaries to keep button within viewport
  //     const maxTopOffset = window.innerHeight - buttonRef.current.offsetHeight - 40;
  //     const minTopOffset = 40;

  //     // Update position only if within boundaries
  //     if (newTopOffset >= minTopOffset && newTopOffset <= maxTopOffset) {
  //       setTopOffset(newTopOffset);
  //     }
  //   }
  // };

  // // Set up global event listeners for drag functionality
  // useEffect(() => {
  //   window.addEventListener("mousemove", onDrag);
  //   window.addEventListener("mouseup", stopDrag);

  //   // Cleanup event listeners on component unmount
  //   return () => {
  //     window.removeEventListener("mousemove", onDrag);
  //     window.removeEventListener("mouseup", stopDrag);
  //   };
  // }, []);

  return (
    <div>
      <RotateButton
        ref={buttonRef}
        variant="contained"
        onClick={handleButtonClick}
        // onMouseDown={startDrag}
        // sx={{ top: `${topOffset}px` }} // Dynamic top position
      >
        Survey Form
      </RotateButton>
    </div>
  );
};

export default SurveyForm;
